/**
 * Created by gavin on 19/2/15.
 */
import axios from "../../utils/axios";

// 用户等级
export function getList(query) {
    return axios({
        url: "sysUserClass/getList",
        method: "get",
        params: query
    });
}

export function update(data) {
    return axios({
        url: "sysUserClass/update",
        method: "post",
        data: data
    });
}

